import { render, staticRenderFns } from "./RecordBase.vue?vue&type=template&id=5b0db14a&scoped=true"
import script from "./RecordBase.vue?vue&type=script&lang=js"
export * from "./RecordBase.vue?vue&type=script&lang=js"
import style0 from "./RecordBase.vue?vue&type=style&index=0&id=5b0db14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0db14a",
  null
  
)

export default component.exports